document.addEventListener('DOMContentLoaded', () => {
    const toggle = document.getElementById('mobile-menu-toggle');
    const mobile = document.getElementById('mobile-menu-container');
    const close = document.getElementById('mobile-menu-close');
    const overlay = document.getElementById('site-overlay');
    const items = [...document.querySelectorAll('#main-menu > li.has-mega-menu')];
    if (!toggle || !mobile || !close) return;

    const backgroundState = new Map();
    const isolateMobile = open => {
        if (!open) {
            backgroundState.forEach((inert, element) => { element.inert = inert; });
            backgroundState.clear();
            return;
        }
        let branch = mobile;
        while (branch.parentElement) {
            [...branch.parentElement.children].forEach(element => {
                if (element === branch || backgroundState.has(element)) return;
                backgroundState.set(element, element.inert);
                element.inert = true;
            });
            branch = branch.parentElement;
            if (branch === document.body) break;
        }
    };

    const setMobile = (open, returnFocus = true) => {
        toggle.setAttribute('aria-expanded', String(open));
        toggle.classList.toggle('active', open);
        mobile.classList.toggle('open', open);
        mobile.inert = !open;
        mobile.setAttribute('aria-hidden', String(!open));
        document.body.classList.toggle('mobile-menu-open', open);
        isolateMobile(open);
        if (open) close.focus();
        else if (returnFocus) toggle.focus();
        else if (mobile.contains(document.activeElement)) document.getElementById('logo')?.focus();
    };
    toggle.addEventListener('click', () => setMobile(mobile.inert));
    close.addEventListener('click', () => setMobile(false));
    mobile.addEventListener('keydown', event => {
        if (event.key !== 'Tab') return;
        const controls = [...mobile.querySelectorAll('a[href], button')]
            .filter(element => !element.closest('[inert]') && element.getClientRects().length);
        const first = controls[0];
        const last = controls[controls.length - 1];
        if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last?.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first?.focus();
        }
    });
    mobile.querySelectorAll('.menu-item-has-children').forEach((item, index) => {
        const link = item.querySelector(':scope > a');
        const submenu = item.querySelector(':scope > .sub-menu');
        if (!link || !submenu) return;
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'submenu-toggle';
        button.setAttribute('aria-label', `${link.textContent.trim()} menu`);
        button.setAttribute('aria-expanded', 'false');
        submenu.id ||= `mobile-submenu-${index}`;
        button.setAttribute('aria-controls', submenu.id);
        submenu.inert = true;
        submenu.setAttribute('aria-hidden', 'true');
        link.after(button);
        button.addEventListener('click', () => {
            const open = button.getAttribute('aria-expanded') !== 'true';
            button.setAttribute('aria-expanded', String(open));
            submenu.classList.toggle('submenu-open', open);
            submenu.inert = !open;
            submenu.setAttribute('aria-hidden', String(!open));
        });
    });

    const setMega = (item, open) => {
        const button = item.querySelector(':scope > .menu-disclosure');
        const panel = item.querySelector('.mega-menu-content');
        item.classList.toggle('active', open);
        button?.setAttribute('aria-expanded', String(open));
        if (panel) {
            panel.classList.toggle('active', open);
            panel.setAttribute('aria-hidden', String(!open));
            panel.inert = !open;
        }
    };
    const closeMega = () => {
        items.forEach(item => setMega(item, false));
        overlay?.classList.remove('visible');
    };
    items.forEach(item => {
        const button = item.querySelector(':scope > .menu-disclosure');
        button?.addEventListener('click', () => {
            const open = !item.classList.contains('active');
            closeMega();
            setMega(item, open);
            overlay?.classList.toggle('visible', open);
        });
        button?.addEventListener('keydown', event => {
            if (event.key !== 'ArrowDown') return;
            event.preventDefault();
            closeMega();
            setMega(item, true);
            overlay?.classList.add('visible');
            item.querySelector('.mega-menu-content a[href]')?.focus();
        });
    });
    // Dismiss only an open dropdown. Keep decorative page content free of click handlers.
    document.addEventListener('pointerdown', event => {
        if (!items.some(item => item.contains(event.target))) closeMega();
    });
    document.addEventListener('focusin', event => {
        if (!items.some(item => item.contains(event.target))) closeMega();
    });
    document.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        if (!mobile.inert) setMobile(false);
        const active = items.find(item => item.classList.contains('active'));
        closeMega();
        active?.querySelector(':scope > .menu-disclosure')?.focus();
    });
    window.addEventListener('resize', () => {
        if (getComputedStyle(toggle).display === 'none' && !mobile.inert) setMobile(false, false);
        if (getComputedStyle(toggle).display !== 'none') closeMega();
    });
});
